//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import checkBox from '../common/checkBox.vue';
export default {
    components: {
        checkBox
    },
    props: ['goodsOrder'],
    data() {
        return {
            refundShow: false,
            refundRemark: '',
            refundCauses: [
                {
                    text: '订单信息拍错（规格/尺码/颜色等）',
                    check: true
                },
                {
                    text: '我不想要了',
                    check: false
                },
                {
                    text: '地址/电话信息填写错误',
                    check: false
                },
                {
                    text: '缺货',
                    check: false
                }
            ],
            refundFlag: true //退款按钮节流
        };
    },
    methods: {
        //打开退款选项
        showRefundAction() {
            this.refundShow = true;
        },
        refundCauseClick(index) {
            this.refundCauses.forEach((item, i) => {
                if (index == i) {
                    item.check = true;
                } else {
                    item.check = false;
                }
            });
        },
        //节流
        buttonFlag(code) {
            if (!this[code]) {
                this.$vux.toast.text('请不要快速点击');
                return false;
            } else {
                this[code] = false;
                setTimeout(() => {
                    this[code] = true;
                }, 1500);
                return true;
            }
        },
        //提交退款
        submitRefund() {
            if (!this.buttonFlag('refundFlag')) {
                return false;
            }
            var refundText = '';
            this.refundCauses.forEach(item => {
                if (item.check) {
                    refundText = item.text;
                }
            });
            var returnReason = refundText + (this.refundRemark ? '。' + this.refundRemark : '');
            let that = this;
            let data = {
                goodsOrderId: that.goodsOrder.goodsOrderId,
                status: that.goodsOrder.status,
                returnReason: returnReason
            };
            that.$axios.post('/api/v1.0/lonbonShop/applyReturn', that.qs.stringify(data)).then(function(response) {
                if (response.status == 200) {
                    that.$vux.toast.text('已申请退款，等待商家确认');
                    that.refundShow = false;
                    that.$emit('loadDetail');
                }
            });
        },
        // 关闭页面
        closePopup() {
            this.refundShow = false;
        },
        focusHandle() {
            document.getElementById('reasonTextarea').scrollIntoView(true);
            document.getElementById('reasonTextarea').scrollIntoViewIfNeeded();
            $('#refundBtn').css('display', 'none');
        },
        blurHandle() {
            $('#refundBtn').css('display', 'block');
        },
        windowResize() {
            let that = this;
            var windowHeight = $(window).height();
            $(window).resize(function() {
                setTimeout(() => {
                    var changeHeight = $(window).height();
                    if (changeHeight < windowHeight) {
                        //焦点移入
                        console.log('焦点移入');
                        that.focusHandle();
                    } else {
                        //焦点移出
                        console.log('焦点移出');
                        that.blurHandle();
                    }
                }, 100);
            });
        }
    },
    mounted() {
        this.windowResize();
    }
};



// WEBPACK FOOTER //
// ./src/pcComponents/mine/doRefund.vue